<template>
  <div>
    <div class="left-box">
      <div class="menu-header">
        <div class="menu-headerlogo">
          <img src="@/assets/images/logo.jpeg" class="header-avatar" />
        </div>
        <div class="header-name">{{ user.nickname }}</div>
      </div>
      <div class="menus">
        <div
          class="menus-item"
          v-for="item in nav"
          :key="item.active"
          :class="{ active: active === item.active }"
          @click="go(item.url)"
          v-if="item.role_id.includes(user.role_id)"
        >
          <div class="menus-icon">
            <i :class="item.icon"></i>
          </div>
          <div class="menus-title">{{ item.name }}</div>
        </div>
        <div
          class="menus-item"
          :class="{active: active == 11}"
          @click="to()"
          v-if="7 == user.id"
        >
          <div class="menus-icon">
            <i class="iconfont icon-xitongrizhi"></i>
          </div>
          <div class="menus-title">日志列表</div>
        </div>
      </div>
      <div class="tel">
        <p>服务电话</p>
        <span></span>
        <i class="iconfont icon-dianhua2"></i>
        <b>400 - 999 - 6541</b>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "leftPage",
  data() {
    return {
      nav: [
        {
          name: "首页",
          active: 0,
          url: "/adminhome/index",
          icon: "iconfont icon-shouye3",
          city_id: 0,
          role_id: [0],
        },
        {
          name: "申报列表",
          active: 1,
          url: "/adminhome/declarelist",
          icon: "iconfont icon-shenbao",
          city_id: -1,
          role_id: [0, 1],
        },
        // {
        //   name: "项目月报列表",
        //   active: 7,
        //   url: "/adminhome/project/index",
        //   icon: "iconfont icon-shenbao",
        //   city_id: -1,
        //   role_id: [0, 1],
        // },
        // {
        //   name: "中期评审资料",
        //   active: 8,
        //   url: "/adminhome/project_list/index",
        //   icon: "iconfont icon-shenbao",
        //   city_id: -1,
        //   role_id: [0, 1, 2],
        // },
        // {
        //   name: "结项评审资料",
        //   active: 9,
        //   url: "/adminhome/end_project_list/index",
        //   icon: "iconfont icon-shenbao",
        //   city_id: -1,
        //   role_id: [0, 1, 2],
        // },
        // {
        //   name: "结项评审资料（补充）",
        //   active: 10,
        //   url: "/adminhome/supply_project_list/index",
        //   icon: "iconfont icon-shenbao",
        //   city_id: -1,
        //   role_id: [0, 1, 2],
        // },
        // {
        //   name: "初审列表",
        //   active: 5,
        //   url: "/adminhome/cdeclarelist",
        //   icon: "iconfont icon-shenbao",
        //   city_id: -1,
        //   role_id: [2],
        // },
        // {
        //   name: "复审列表",
        //   active: 6,
        //   url: "/adminhome/fdeclarelist",
        //   icon: "iconfont icon-shenbao",
        //   city_id: -1,
        //   role_id: [2],
        // },
        // {
        //   name: "专家列表",
        //   active: 4,
        //   url: "/adminhome/expertlist",
        //   icon: "iconfont icon-shenhe",
        //   city_id: 0,
        //   role_id: [0],
        // },
        {
          name: "机构列表",
          active: 2,
          url: "/adminhome/orglist",
          icon: "iconfont icon-jigou",
          city_id: 0,
          role_id: [0],
        },
        // {
        //   name: "日志列表",
        //   active: 11,
        //   url: "/adminhome/loglist",
        //   icon: "iconfont icon-xitongrizhi",
        //   city_id: 0,
        //   role_id: [0],
        //   ids:[7]
        // },
        {
          name: "个人中心",
          active: 3,
          url: "/adminhome/pass",
          icon: "iconfont icon-zhanghao1",
          city_id: -1,
          role_id: [0, 1, 2],
        },
      ],
    };
  },
  props: {
    active: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    token() {
      return this.$store.state.admintoken;
    },
    user() {
      return this.$store.state.adminuser;
    },
  },
  components: {},
  created() {},
  methods: {
    go(path) {
      this.$router.replace(path);
    },
    to() {
      this.$router.replace('/adminhome/loglist');
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.left-box {
  width: 100%;

  .menu-header {
    width: 100%;
    min-height: 157px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 25px;

    .header-name {
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      font-weight: bold;
      line-height: 26px;
      padding-top: 15px;
    }

    .menu-headerlogo {
      width: 95px;
      height: 95px;
      border-radius: 85px;
      overflow: hidden;
      margin: 0 auto;

      .header-avatar {
        width: 100%;
        height: 100%;
        //object-fit: scale-down;
      }
    }

    .header-name {
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      color: #fff;
      //margin-top: 12px;
    }
  }

  .tel {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 20px 35px;
    position: relative;
    border-top: 1px solid #ffffff;
    border-bottom: 1px solid #ffffff;

    p {
      width: 100%;
      font-size: 14px;
      color: #ffffff;
    }

    span {
      width: 30px;
      height: 2px;
      background: #ffffff;
    }

    b {
      font-size: 14px;
      color: #ffffff;
    }

    i {
      position: absolute;
      right: 0;
      bottom: -10px;
      z-index: -1;
      font-size: 90px;
      color: rgba(255, 255, 255, 0.1);
    }
  }

  .menus {
    width: 100%;

    .menus-item {
      width: 100%;
      height: 130px;
      border-top: 1px solid #ffffff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;

      &.active {
        border-left: 3px solid #ffffff;
        border-top: none;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0)
        );
      }

      .menus-title {
        width: 100%;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        font-weight: bold;
        margin-top: 10px;
      }

      .menus-icon {
        width: 100%;
        text-align: center;

        i {
          font-size: 38px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
